import { Series } from "../../../models/historical-charts/series";
import styleCSS from "./chart-series-list.style.scss?inline"

export class SeriesVisibilityChangedEvent extends Event {
  static EVENT_NAME = "SeriesVisibleChanged"
  constructor(type: string, public seriesIndex: number, public visible: boolean) { super(type) }
}

export class SeriesListComponent extends HTMLElement {
  private readonly ACTIVE_CLASSNAME = 'active'
  private _seriesButtons: HTMLElement[] = []

  constructor() {
    super()
    this.className = "series-div"
    
    // Add styles to shadow DOM
    const shadowRoot = this.attachShadow({ mode: 'open' });
    const style = document.createElement('style');
    style.textContent = styleCSS;
    shadowRoot.appendChild(style);
    
    // Create a container for the content
    const wrapper = document.createElement('div');
    wrapper.className = 'series-div';

    const container = document.createElement('div');
    container.className = 'series-container';
    wrapper.appendChild(container);

    shadowRoot.appendChild(wrapper);
  }

  init(seriesList: Series[]) {
    this._seriesButtons = seriesList.map(this.createSeriesButton.bind(this))
    const container = this.shadowRoot?.querySelector('.series-container');
    if (container) {
      for (let index = 0; index < this._seriesButtons.length; index++) {
        container.appendChild(this._seriesButtons[index])
      }
    }
  }

  private createSeriesButton(series: Series, index: number): HTMLButtonElement {
    const btn: HTMLButtonElement = document.createElement('button')
    btn.innerText = series.name
    btn.classList.add(this.ACTIVE_CLASSNAME)
    btn.dataset.index = index.toString()
    btn.style.cursor = 'pointer'
    btn.style.setProperty('--before-color', series.options.color as string)
    btn.setAttribute('role', 'tab')
    btn.setAttribute('aria-pressed', 'true')
    btn.addEventListener('click', () => this.toggleSeries(btn, index))
    return btn
  }

  private toggleSeries(btn: HTMLButtonElement, index: number) {
    const isActive = btn.classList.contains(this.ACTIVE_CLASSNAME)
    btn.classList.toggle(this.ACTIVE_CLASSNAME, !isActive)
    btn.setAttribute('aria-pressed', String(!isActive))
    this.dispatchEvent(new SeriesVisibilityChangedEvent(SeriesVisibilityChangedEvent.EVENT_NAME, index, !isActive))
  }
}
